import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["disabled", "type", "aria-label", "aria-current"]
const _hoisted_2 = ["href", "title", "target"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.format === 'button')
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: _normalizeClass(["button", _ctx.setClases()]),
          disabled: _ctx.isDisabled(),
          type: _ctx.type,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickButton && _ctx.onClickButton(...args))),
          "aria-label": _ctx.ariaLabel,
          "aria-current": _ctx.ariaCurrent
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 10, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.format === 'link')
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          class: _normalizeClass(["button", _ctx.setClases()]),
          to: _ctx.href
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 8, ["class", "to"]))
      : _createCommentVNode("", true),
    (_ctx.format === 'anchor')
      ? (_openBlock(), _createElementBlock("a", {
          key: 2,
          class: _normalizeClass(["button", _ctx.setClases()]),
          href: _ctx.href,
          title: _ctx.title,
          target: _ctx.target
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 10, _hoisted_2))
      : _createCommentVNode("", true)
  ], 64))
}